import { EInstitutionType } from '@ucheba/store/institutions/item/types'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { useMemo } from 'react'

interface IProps {
  institutionType?: number
  programType?: number
}

interface IUseWantToStudyCore {
  (props: IProps): {
    /* это колледж или университет? */
    isCollegeOrUniversity: boolean | undefined

    /* это учебный центр? */
    isTypeOfApplicationProgram: boolean | undefined
  }
}

export const useWantToStudyCore: IUseWantToStudyCore = (props) => {
  const { institutionType, programType } = props

  // это колледж или университет?
  const isCollegeOrUniversity = useMemo(() => {
    if (institutionType)
      return [EInstitutionType.College, EInstitutionType.University].includes(
        institutionType
      )

    return undefined
  }, [institutionType])

  const isTypeOfApplicationProgram = useMemo(() => {
    if (programType)
      return [
        EProgramTypes.vocational,
        EProgramTypes.vocationalSpo,
        EProgramTypes.vocationalNpo,
        EProgramTypes.higher,
        EProgramTypes.higherBachelor,
        EProgramTypes.higherSpeciality,
      ].includes(programType)

    return undefined
  }, [programType])

  return {
    isCollegeOrUniversity,
    isTypeOfApplicationProgram,
  }
}
